import { FeatureFlagService } from '../services';
import { SharedModule } from '../shared.module';
import { FeatureFlagsEnum } from '../enums';

export function IsFeatureFlagEnabled(flagKey: FeatureFlagsEnum | string): Function {
    return function (target: Record<string, unknown>, propertyKey: string): void {
        const featureFlagServiceInstance: FeatureFlagService = SharedModule?.injector.get(FeatureFlagService);

        Object.defineProperty(target, propertyKey, {
            value: featureFlagServiceInstance?.getFlag(flagKey),
        });
    };
}
